// TODO: move to boysenberry s3
export const PLACEHOLDER_IMAGE = 'https://img-cdn.misfitsmarket.com/images/placeholder.png';

export const AISLE_PATH_PREFIX = '/shop/aisle';

export const FEATURED_AISLE = {
    id: 'featured',
    name: 'Featured',
    url: '/shop',
};

export const BUY_IT_AGAIN_AISLE = {
    id: 'buy-it-again',
    name: 'Buy It Again',
    url: '/shop/aisle/buy-it-again',
};

export const MEMBER_DEALS_AISLE = {
    id: 'member-deals',
    name: 'Member Deals',
    url: '/shop/aisle/member-deals',
};

export const SHOP_WITH_POINTS_AISLE = {
    id: 'shop-with-points',
    name: 'Shop with Points',
    url: '/shop/browse/misfits+perks',
};

export const SHOP_ALL_AISLE = {
    id: 'all-items',
    name: 'Shop All',
    url: `${AISLE_PATH_PREFIX}/all`,
};

export const BEST_DEALS_AISLE = {
    id: 'best-deals',
    name: 'Best Deals',
    url: `${AISLE_PATH_PREFIX}/best-deals`,
};

export const RESCUED_AISLE = {
    id: 'rescued',
    name: 'Rescued',
    url: `${AISLE_PATH_PREFIX}/rescued`,
};

export const WINE_AISLE_NAME = 'Wine Shop';
export const FRUIT_AISLE_NAME = 'Fruit';
export const VEGETABLE_AISLE_NAME = 'Vegetables';

// NOTE: We may want to display protienMinimum instead of a hardcoded value from account data in the future
export const WAIVE_COLD_PACK_FEE_MIN = 30;

export const ALCOHOL_SERVICE_FEE = 8.99;
export const MIN_WINE_BOTTLE_QTY_TO_SHIP = 3;
export const MIN_WINE_BOTTLE_QTY_TO_WAIVE_FEE = 6;
export const MIN_WINE_BOTTLE_QTY_FOR_PERCENT_DISCOUNT_TIER_1 = 9;
export const MIN_WINE_BOTTLE_QTY_FOR_PERCENT_DISCOUNT_TIER_2 = 12;
export const WINE_PERCENT_DISCOUNT_TIER_1 = 10;
export const WINE_PERCENT_DISCOUNT_TIER_2 = 15;

export const MIN_WINE_BOTTLE_QTY_TO_SHIP_COPY = 'three';
export const MIN_WINE_BOTTLE_QTY_TO_WAIVE_FEE_COPY = 'six';
export const MIN_WINE_BOTTLE_QTY_FOR_PERCENT_DISCOUNT_TIER_1_COPY = 'nine';

export const MAX_CREDITS_PER_ORDER = 250;

/**
 * TODO: refactor this out in favor of account.nextOrder.maxRedeemablePoints?
 * See: https://github.com/MisfitsMarket/boysenberry/pull/1042/files#r2260735510
 */
export const MAX_REDEEMABLE_POINTS_PER_ORDER = 1000;

/*
    IDs for aisles containing duplicated items.
    Used to remove aisles with duplicate items from the Shop All aisle, Best Deals aisle, and M+ Deals page.

        - Our Brands (id: 1160)
        - Plant Based (id: 1172)
        - Gluten Free (id: 939)
        - Back to School (id: 1959)
        - Spice Up Your Routine (id: 1970)
        - Fall Flavors (id: 1971)
        - Thanksgiving Essentials (id: 1972)
        - Holiday Must Haves (id: 1973)
        - Saved & Rescued (id: 1925)
        - Black Friday Sale (id: 1655)
        - Try Something New (id: 1998)
        - Staff Picks (id: 2003)
        - Earth Friendly (id: 2013)
        - Best of Misfits (id: 2022)
        - Summer Shop (id: 2043)
        - Hosting & Entertaining (id: 2157)
        - Cold Pack (id: 945)
*/
export const DUPLICATE_ITEMS_AISLE_IDS = [
    1160, 1172, 939, 1959, 1970, 1971, 1972, 1973, 1925, 1655, 1998, 2003, 2013, 2022, 2043, 2157, 945,
];

// Aisles that are considered new and should be tagged with a NEW tag
export const NEW_AISLES = ['Best Deals'];

// BANNER_4 maps to 'BANNER_1' due to a Figma-vs-tooling naming discrepancy
export const BANNER_SLICE_TYPES = {
    BANNER_4: 'BANNER_1',
    BANNER_CAROUSEL_1: 'BANNER_CAROUSEL_1',
    BANNER_CAROUSEL_2: 'BANNER_CAROUSEL_2',
    BANNER_CAROUSEL_3: 'BANNER_CAROUSEL_3',
};

/**
 * Slices that render products (not banners, etc).
 */
export const PRODUCT_SLICE_TYPES = {
    PRODUCT_SPOTLIGHT: 'PRODUCT_SPOTLIGHT',
    PRODUCT_CAROUSEL_1: 'PRODUCT_CAROUSEL_1',
    PRODUCT_CAROUSEL_2: 'PRODUCT_CAROUSEL_2',
    PRODUCT_CAROUSEL_3: 'PRODUCT_CAROUSEL_3',
};
